import modaal from 'modaal'

$(".js-modal-trigger").modaal();
